import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ColorSchemeService } from '@fantaz/shared/services/color-scheme';

@Component({
  selector: 'fz-filter-button',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss'],
})
export class FilterComponent {
  @Input()
  showFilter = false;

  @Input()
  isSelected = false;

  constructor(private readonly colorSchemeService: ColorSchemeService) {
    this.colorSchemeService.init();
  }

  @Output() filterChange = new EventEmitter<boolean>();

  toggleFilter() {
    this.showFilter = !this.showFilter;
    this.filterChange.emit(this.showFilter);
  }

  get colorScheme() {
    return this.colorSchemeService.get();
  }
}
